import { useScreenSize } from '../../../hooks/useScreenSize';
import { background } from '../../../themeConfig';
import { PrivacyPolicy } from '../Register/PrivacyPolicy';

const SupportPrivacyPolicyPage = () => {
  const { width } = useScreenSize()

  return (
    <div style={classes.main} direction="coloum">
      <div style={{ ...classes.root, width: width < 600 ? '90vw' : width < 1000 ? '60vw' : '30vw' }}>
        <PrivacyPolicy />
      </div>
    </div>
  );
}

const classes = {
  main: {
    height: '100vh',
    minHeight: '100vh',
    display: 'flex',
    backgroundImage: `url(${background})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    minwidth: 400,
    overflowX: 'hiden',
    alignItems: 'center',
    justifyContent: 'center',
  },
  root: {
    boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.2)',
    height: 'auto',
    overflowY: 'auto',
    background: '#fafafa',
    borderRadius: '3%',
    display: 'flex',
    flexDirection: 'flex',
    justifyContent: 'center',
    padding: '20px',
    margin: '10%'
  },
}

export default SupportPrivacyPolicyPage;